import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Table } from 'reactstrap';
import FormCard from '../../../shared/components/custom/FormCard';
import Api from '../../../util/api';
import { partial } from '../../../util/translation/translation';

const p = partial('chat');

// Messages, writers and reactions per month, for all chats or one
const ChatActivityCard = ({ chatId }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    Api.chat
      .getActivity({ months: 6, chatId })
      .then((data) => setRows(data || []))
      .catch(() => setRows([]));
  }, [chatId]);

  return (
    <FormCard
      title={p('activity')}
      bodyClassName="form-card__body--flush"
      className="mb-3"
    >
      <Table responsive striped className="table--roomy table--stack">
        <thead>
          <tr>
            <th>{p('month')}</th>
            {!chatId && <th>{p('chat')}</th>}
            <th>{p('messages')}</th>
            <th>{p('writers')}</th>
            <th>{p('reactions')}</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={chatId ? 4 : 5} className="text-muted">
                {p('noActivity')}
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={`${row.chatId}-${row.month}`}>
                <td className="table-stack__primary">
                  {moment(`${row.month}-01`).format('MMM YYYY')}
                </td>
                {!chatId && (
                  <td data-label={p('chat')}>{row.chatName || '-'}</td>
                )}
                <td data-label={p('messages')}>{row.messages}</td>
                <td data-label={p('writers')}>{row.writers}</td>
                <td data-label={p('reactions')}>{row.reactions}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </FormCard>
  );
};

export default ChatActivityCard;
